import { Component, HostListener, ElementRef, Input, Injector, Type } from "@angular/core";
import { trigger, state, animate, transition, style, AnimationEvent } from "@angular/animations";
import { BfxBlotterOrdersContextMenu } from "../bfx-blotter-orders/bfx-blotter-orders-contextmenu";
import { BfxOrderDetailsContextMenuService } from "./bfx-order-details-contextmenu.service";

import {
  BfxBlotterOrdersContextMenuItem,
  OrderDataPrimaryLookupService,
} from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
import { BfxOrderDetailsComponent } from "./bfx-order-details.component";
const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-order-details-context-menu",
  // TODO: move changes to base and drop
  templateUrl: "./html/bfx-order-details-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BfxOrderDetailsContextMenu extends BfxBlotterOrdersContextMenu {
  private static nativeMenuCounter: number = 0;

  /**
   * Works on desktop
   * Could be improved, triggers multiple times (both on browser and desktop) depending on how many order detail windows are open
   */
  @HostListener("window:mousedown", ["$event"])
  public handleMouseWheelEvent(event: MouseEvent): void {
    if (this.show) {
      this.hideMenu();
    }
  }

  constructor(
    injector: Injector,
    lookupService: OrderDataPrimaryLookupService,
    private orderDetails: BfxOrderDetailsComponent,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BfxOrderDetailsContextMenuService> {
    return BfxOrderDetailsContextMenuService;
  }

  // Override of base class method to show menu above Order Actions button. Parent popup
  // will have overflow: hidden, so cannot display below the view
  public showHideMenuStarted($event: AnimationEvent, menuRef: any) {
    if (`show` === $event.toState) {
      let height: number = menuRef.offsetHeight;
      let width: number = menuRef.offsetWidth;
      let maxWidth: number = window.innerWidth;

      this.position.y = this.position.y - height;

      if (width + this.position.x > maxWidth) {
        this.position.x = maxWidth - width;
      }
    }
  }

  public isItemEnabled(item: BfxBlotterOrdersContextMenuItem) {
    // check both states as does not hide unavailable item
    if (item == null) {
      return false;
    }
    return item.state.available && item.state.enabled;
  }

  protected createMenuId(): string {
    return `${BfxOrderDetailsContextMenu.nativeMenuCounter++}-details-menu`;
  }

  public selectedMenuItem(item: BfxBlotterOrdersContextMenuItem, event?: any) {
    let selectedIds: [] = null;

    if (this.orderDetails != null && this.orderDetails.selectedIds != null) {
      selectedIds = this.orderDetails.selectedIds;
    }

    if (item.isEnabled) {
      this.menuService.fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        selectedIds,
        null,
        item.state,
        null,
        null,
        event,
      );
      this.hideMenu();
    }
  }
}
